import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import moment from 'moment';
import { dispatch } from '@store';
import { actions as globalVariablesActions } from '@store/global-variables';
import { setTimeout_ } from '@helpers';
import { calculateBasketTotalsFromItems, EMPTY_BASKET_TOTALS, normalizeBasketItem } from '@helpers/basket';
import { ApiService } from '../../api/api.service';

function extractResponseData(data) {
  if (!data) {
    return null;
  }

  if (Array.isArray(data)) {
    return {
      seats: data
    };
  }

  if (_typeof(data) === 'object') {
    return data;
  }

  return null;
}
/** Извлекает массив корзины из ответа API (reserve/unreserve/current возвращают BasketPreviewViewModel). */


function _getBasketFromResponse(response) {
  var _ref, _data$seats;

  var data = extractResponseData(response === null || response === void 0 ? void 0 : response.data);

  if (!data) {
    return [];
  }

  var arr = (_ref = (_data$seats = data.seats) !== null && _data$seats !== void 0 ? _data$seats : data.content) !== null && _ref !== void 0 ? _ref : data.items;
  return Array.isArray(arr) ? arr : [];
}

function _getBasketTotalsFromResponse(response, items) {
  var data = extractResponseData(response === null || response === void 0 ? void 0 : response.data);

  if (data && data.basketFinalTotal != null) {
    var _data$basketBaseTotal, _data$basketFinalTota, _data$basketTotalDisc;

    return {
      basketBaseTotal: Number((_data$basketBaseTotal = data.basketBaseTotal) !== null && _data$basketBaseTotal !== void 0 ? _data$basketBaseTotal : 0),
      basketFinalTotal: Number((_data$basketFinalTota = data.basketFinalTotal) !== null && _data$basketFinalTota !== void 0 ? _data$basketFinalTota : 0),
      basketTotalDiscount: Number((_data$basketTotalDisc = data.basketTotalDiscount) !== null && _data$basketTotalDisc !== void 0 ? _data$basketTotalDisc : 0)
    };
  }

  return calculateBasketTotalsFromItems(items);
}

var BasketServiceClass = /*#__PURE__*/function () {
  function BasketServiceClass() {
    _classCallCheck(this, BasketServiceClass);

    _defineProperty(this, "basketClearTimeout", 0);

    _defineProperty(this, "_externalChangeBasketEvent", new Event('onExternalChangeBasket'));
  }

  _createClass(BasketServiceClass, [{
    key: "getBasket",
    value: function () {
      var _getBasket = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet("/webapi/reserved-seat/current", {
                  blocked: false,
                  dontHandleError: true
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getBasket() {
        return _getBasket.apply(this, arguments);
      }

      return getBasket;
    }()
    /**
     * Берём элемент с минимальным reservedTill; задержка = reservedTill − datetime этого элемента (локальное время сервера).
     * По срабатыванию таймера очищаем всю корзину.
     */

  }, {
    key: "parseBasket",
    value: function parseBasket(basket) {
      var _this = this;

      var minReservedTill;
      var datetimeOfMinItem;
      basket.forEach(function (item) {
        var reservedTill = moment(item.reservedTill);

        if (!minReservedTill || reservedTill.isBefore(minReservedTill)) {
          minReservedTill = reservedTill;
          datetimeOfMinItem = item.datetime;
        }
      }); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      if (minReservedTill && datetimeOfMinItem) {
        if (this.basketClearTimeout) {
          clearTimeout(this.basketClearTimeout);
        }

        var delayMs = Math.max(0, minReservedTill.diff(moment(datetimeOfMinItem), 'seconds')) * 1000;
        this.basketClearTimeout = setTimeout_(function () {
          _this.clearBasket();
        }, delayMs);
      }

      return basket.map(normalizeBasketItem);
    }
  }, {
    key: "getBasketFromResponse",
    value: function getBasketFromResponse(response) {
      return _getBasketFromResponse(response);
    }
  }, {
    key: "getBasketTotalsFromResponse",
    value: function getBasketTotalsFromResponse(response, items) {
      return _getBasketTotalsFromResponse(response, items);
    }
  }, {
    key: "updateStoreFromResponse",
    value: function updateStoreFromResponse(response) {
      if (!response || _typeof(response) !== 'object' || 'error' in response) {
        return [];
      }

      var axiosResponse = response;
      var items = this.parseBasket(_getBasketFromResponse(axiosResponse));

      var totals = _getBasketTotalsFromResponse(axiosResponse, items);

      dispatch(globalVariablesActions.setValue({
        key: 'basket',
        value: items
      }));
      dispatch(globalVariablesActions.setValue({
        key: 'basketTotals',
        value: totals
      }));
      return items;
    }
  }, {
    key: "clearBasket",
    value: function clearBasket() {
      dispatch(globalVariablesActions.setValue({
        key: 'basket',
        value: []
      }));
      dispatch(globalVariablesActions.setValue({
        key: 'basketTotals',
        value: EMPTY_BASKET_TOTALS
      }));
    }
  }, {
    key: "reloadBasket",
    value: function () {
      var _reloadBasket = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.getBasket();

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", this.updateStoreFromResponse(response));

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", []);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function reloadBasket() {
        return _reloadBasket.apply(this, arguments);
      }

      return reloadBasket;
    }()
  }, {
    key: "reserveSeat",
    value: function () {
      var _reserveSeat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(reserveData) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiPost("/webapi/reserved-seat/reserve", reserveData, {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reserveSeat(_x) {
        return _reserveSeat.apply(this, arguments);
      }

      return reserveSeat;
    }()
  }, {
    key: "unreserveSeat",
    value: function () {
      var _unreserveSeat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(reserveData) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", ApiService.apiPut("/webapi/reserved-seat/unreserve", reserveData, {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function unreserveSeat(_x2) {
        return _unreserveSeat.apply(this, arguments);
      }

      return unreserveSeat;
    }()
  }, {
    key: "changeSeatCategory",
    value: function () {
      var _changeSeatCategory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(reserveData) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", ApiService.apiPut("/webapi/reserved-seat/category", reserveData, {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function changeSeatCategory(_x3) {
        return _changeSeatCategory.apply(this, arguments);
      }

      return changeSeatCategory;
    }()
    /** body: {} для авторизованного; { lastName, firstName, middleName?, email, phone } для гостя. dontHandleError: ошибки 422 показываем на форме. */

  }, {
    key: "createOrder",
    value: function () {
      var _createOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(body) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", ApiService.apiPost("/webapi/order/new/from-reserve", body, {
                  blocked: true,
                  dontHandleError: true
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function createOrder(_x4) {
        return _createOrder.apply(this, arguments);
      }

      return createOrder;
    }()
  }, {
    key: "getOrder",
    value: function () {
      var _getOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(orderId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", ApiService.apiGet("/webapi/order/".concat(orderId, "/info"), {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getOrder(_x5) {
        return _getOrder.apply(this, arguments);
      }

      return getOrder;
    }()
  }, {
    key: "receiveFreeOrder",
    value: function () {
      var _receiveFreeOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(orderId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", ApiService.apiPut("/webapi/order/".concat(orderId, "/issue"), undefined, {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function receiveFreeOrder(_x6) {
        return _receiveFreeOrder.apply(this, arguments);
      }

      return receiveFreeOrder;
    }()
  }, {
    key: "getAppConfig",
    value: function () {
      var _getAppConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", ApiService.apiGet("/webapi/appconfig", {
                  dontHandleError: true
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getAppConfig() {
        return _getAppConfig.apply(this, arguments);
      }

      return getAppConfig;
    }()
  }, {
    key: "downloadOrder",
    value: function () {
      var _downloadOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(orderId) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", ApiService.apiPost("/webapi/ticket/pdf/print/order/".concat(orderId), undefined, {
                  blocked: true,
                  responseType: 'blob'
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function downloadOrder(_x7) {
        return _downloadOrder.apply(this, arguments);
      }

      return downloadOrder;
    }()
  }, {
    key: "externalChangeBasketEvent",
    value: function externalChangeBasketEvent() {
      document.dispatchEvent(this._externalChangeBasketEvent);
    }
  }]);

  return BasketServiceClass;
}();

var BasketService = new BasketServiceClass();
export { BasketService, BasketServiceClass };